module.exports = __webpack_public_path__ + "static/img/section-bg1.6d62b7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg/section-bg1.png
// module id = 7zPZ
// module chunks = 2